module.exports = __webpack_public_path__ + "img/product_black.52b1948c.png";